const getApiBase = () => {
    let url = process.env.REACT_APP_API_URL || "https://news-portal-l6pf.onrender.com";
    url = url.replace(/\/$/, "");
    if (url.endsWith("/api")) url = url.slice(0, -4);
    return url;
};

export const getNewsShareUrl = (item) => {
    const id = item?._id || item?.id;
    if (!id) {
        return typeof window !== "undefined" ? window.location.href : "";
    }

    return `${getApiBase()}/news/share/${id}`;
};
